<template>
  <v-card class="mx-auto" max-width="400" min-height="180" style="cursor:pointer; border: 1px solid #DDDDDD; border-radius: 8px; box-shadow: none;" :disabled="!widget.isAllowed || widget.license > currentLicense">
    <v-card-text @click="$emit('select-widget', widget)">
       
        <v-row>
            <v-col cols="9">
                <div style="display: flex; align-items: center; gap: 10px;">
                    <h3 style="color: #185EA9;">{{st(widget.title)}}</h3>
                     <v-chip x-small color="pink" text-color="white" style="margin-bottom: 5px;" v-if="widget.isNew">Nuevo</v-chip>
                </div>
                <p>{{st(widget.description)}}</p>
            </v-col>
            <v-col cols="3" style="text-align:center;">
                <div style="height: 60px; width: 60px; background-color: #E7EEF6; border-radius: 100%; display: flex; align-items: center; justify-content: center; margin: 0 auto 5px;">
                    <v-icon x-large v-if="(widget.type==0)" style="color: #185EA9;">table_chart</v-icon>
                    <v-icon x-large v-if="(widget.type==1)" style="color: #185EA9;">insert_chart</v-icon>
                    <v-icon x-large v-if="(widget.type==2)" style="color: #185EA9;">show_chart</v-icon>
                    <v-icon x-large v-if="(widget.type==3)" style="color: #185EA9;">pie_chart</v-icon>
                    <v-icon x-large v-if="(widget.type>3)" style="color: #185EA9;">extension</v-icon>
                </div>
                <v-chip small color="green" text-color="white" style="margin-bottom: 5px;" v-if="widget.license==1">Advanced</v-chip>
                <v-chip small color="blue" text-color="white" style="margin-bottom: 5px;" v-if="widget.license==2">Premium</v-chip>
                <!--<v-chip small color="pink" text-color="white" style="margin-bottom: 5px;" v-if="widget.isNew">Nuevo</v-chip>-->
            </v-col>
            <v-col cols="12" v-if="!widget.isAllowed || widget.license > currentLicense">
                <v-icon x-small class="pr-1">lock</v-icon>
                <span v-if="widget.license==1">{{$t('wkt.admin.dashboards.select.license-business')}} </span>
                <span v-if="widget.license==2">{{$t('wkt.admin.dashboards.select.license-corporate')}} </span>
            </v-col>
        </v-row>
    </v-card-text>
  </v-card>
</template>
    
    <script>
     
    
      import BaseModule from '../../common/BaseModule.js' 
     
    
      export default {
        name: 'SelectWidgetCard',
        mixins: [BaseModule],
        components: {
        },
        props: ['widget', 'currentLicense'],
        mounted() { 
        },
        methods: {
        },
        data() {
          return {
           
          }
        }
      }
      </script>
      